import api from './client.js'

export const imagecompoAPI = {
  getHealth:        () => api.get('/imagecompo/health'),
  getActiveShow:    () => api.get('/imagecompo/active-show'),
  getState:         () => api.get('/imagecompo/state'),
  updateState:      (patch) => api.patch('/imagecompo/state', patch),

  // Shows
  listShows:        () => api.get('/imagecompo/shows'),
  createShow:       (data) => api.post('/imagecompo/shows', data),
  updateShow:       (id, data) => api.patch(`/imagecompo/shows/${id}`, data),
  awardResults:     (id)       => api.post(`/imagecompo/shows/${id}/award-results`),
  deleteShow:       (id) => api.delete(`/imagecompo/shows/${id}`),
  activateShow:     (id) => api.post(`/imagecompo/shows/${id}/activate`),
  resetShow:        (id) => api.post(`/imagecompo/shows/${id}/reset`),
  populateShowMock: (id) => api.post(`/imagecompo/shows/${id}/populate`),

  // Teams
  listTeams:        (showId) => api.get(`/imagecompo/shows/${showId}/teams`),
  createTeam:       (showId, data) => api.post(`/imagecompo/shows/${showId}/teams`, data),
  updateTeam:       (id, data) => api.patch(`/imagecompo/teams/${id}`, data),
  deleteTeam:       (id) => api.delete(`/imagecompo/teams/${id}`),
  uploadTeamLogo:   (id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/imagecompo/teams/${id}/logo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // Entries
  listEntries:      (showId) => api.get(`/imagecompo/shows/${showId}/entries`),
  createEntry:      (showId, data) => api.post(`/imagecompo/shows/${showId}/entries`, data),
  updateEntry:      (id, data) => api.patch(`/imagecompo/entries/${id}`, data),
  deleteEntry:      (id) => api.delete(`/imagecompo/entries/${id}`),
  uploadEntryImage: (id, file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post(`/imagecompo/entries/${id}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // Submissions (user)
  getMySubmission:      () => api.get('/imagecompo/my-submission'),
  createMySubmission:   (data) => api.post('/imagecompo/my-submission', data),
  updateMySubmission:   (data) => api.patch('/imagecompo/my-submission', data),
  uploadMyImage:        (file) => {
    const fd = new FormData(); fd.append('file', file)
    return api.post('/imagecompo/my-submission/image', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  withdrawMySubmission: () => api.post('/imagecompo/my-submission/withdraw'),

  // Admin submissions
  listAdminSubmissions: () => api.get('/imagecompo/admin/submissions'),
  approveSubmission:    (id) => api.post(`/imagecompo/admin/submissions/${id}/approve`),
  rejectSubmission:     (id) => api.post(`/imagecompo/admin/submissions/${id}/reject`),
  adminWithdrawSubmission: (id) => api.post(`/imagecompo/admin/submissions/${id}/withdraw`),

  // Scores (admin)
  adminGetScores:   () => api.get('/imagecompo/admin/scores'),
  adminSaveScores:  (scores) => api.put('/imagecompo/admin/scores', { scores }),
}
